import { Button, Icon, Loading } from '@startlibs/components';
import { darken } from 'polished';
import {getColor, media, styledExtend} from '@startlibs/utils'
import styled, {css} from 'styled-components/macro'

export const WidgetHeader = styled.div`
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  position: relative;
  min-height: 4rem;
  width: auto;
  color: white;
  background: ${getColor('main')};
  h4 {
    margin-bottom: 0;
    font-size: 14px;
  }
  * {
    flex-shrink: 0;
  }
  a {
    opacity: 0.8;
    text-decoration: underline;
    :hover {
      opacity: 0.9;
    }
  }
  ${Loading} {
    margin-right: 0.75rem;
  }
  ${media.mobile`
    padding: 1rem 1.25rem;
    min-height: 58px;
    h4 {
      font-size: 16px;
      font-weight: 500;
    }
  `}
  ${props => props.isOnDialog ? css`
    border-radius: 6px 6px 0 0;
    padding: 1.25rem 1.5rem 1.25rem 2rem;
    margin: -2rem -2rem 2rem;
    ${media.mobile`
      margin: -1.5rem -1.5rem 2rem;
    `}
    ${Loading} {
      margin-right: 1.25rem;
    }
  `: css`
    :hover {
      cursor: pointer;
      background-color: ${props => (darken(0.01, getColor('main')(props)))};
    }
  `}
`
export const WidgetHeaderDetail = styled.div`
  color: rgba(0,0,0,0.4);
  font-size: 12px;
  margin-top: 1px;
`

export const WidgetBody = styled.div`
  position: relative;
  padding: 1rem;
  overflow-y: auto;
  margin-bottom: 0;
  border-top: 1px solid rgba(0,0,0,0.1);
  min-width: 26rem;
  transition: all ease-out 0.4s;
  min-height: 6rem;
  ::-webkit-scrollbar {
    width: 16px;
    height: 16px;
    background: rgba(0,0,0,0.05);
    border-radius: 0 5px 5px 0;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.25);
    border-radius: 100px;
    background-clip: padding-box;
    border: 4px solid transparent;
    min-height: 30px;
    min-width: 30px;
    &:hover {
      background: rgba(0,0,0,0.35);
      background-clip: padding-box;
      border: 4px solid transparent;
    }
  }
`

export const PanelButton = styled(Icon)`
  margin-left: 0.5rem;
  width: 2.75rem;
  height: 2.75rem;
  line-height: 34px;
  font-size: 21px;
  text-align: center;
  border-radius: 50%;
  color: white;
  background-color: rgba(255,255,255,0.15);
  cursor: pointer;
  display: inline-block;
  :hover {
    background-color: rgba(255,255,255,0.2);
  }
`
export const WidgetIcon = styledExtend(Icon)`
  font-size: 32px;
  color: ${getColor('main')};
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  ${media.mobile`
    left: 1.25rem;
  `}
`

export const WidgetPanelComponent = styled.div`
  position: static;
  bottom: 0;
  will-change: transform;
  z-index: 50;
  box-shadow: 0 0 10px 0px rgba(0,0,0,0.2), 0 0 2px 0px rgba(0,0,0,0.15);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: white;
  transition-property: transform;
  transition-duration: 0.4s;
  transition-timing-function: ease-out;
  overflow: hidden;
  transform-origin: bottom;
  @supports (flex-wrap: wrap) {
    display: flex;
    flex-direction: column;
  }
  ${props => props.closing && css`
    transform: translateY(100%);
  `}
  ${media.desktop`
    width: 19rem;
    transition-property: transform, max-height, width;
    @media (max-height:450px) {
      max-height: 100%;
    }
    ${props => props.maximized ? css`
      max-height: 390px;
      width: 31rem;
      max-width: 31rem;
      ${WidgetHeader} {
        min-height: 55px;
      }
      ${WidgetIcon} {
        font-size: 34px;
      }
    `:`
      max-height: 48px;
      @supports (transform: translateY(calc(100% - 48px))) {
        transform: translateY(calc(100% - 48px));
        max-height: 390px;
      }
      ${WidgetHeader} {
        h4 {
          padding-top: 0.75rem;
        }
        @supports (align-items: center) {
          h4 {
            padding-top: 0;
          }
        }
      }
    `}
  `}
  ${media.mobile`
    width: 100%;
    right: 0;
    left: 0;
    @media (max-height:450px) {
      max-height: 100%;
    }
    ${props => props.maximized ? `
      max-height: 80%;
      ${WidgetHeader} {
        padding: 14px 1.5rem;
      }
      ${WidgetIcon} {
        font-size: 34px;
      }
    `:css`
      max-height: 58px;
      @supports (transform: translateY(calc(100% - 58px))) {
        transform: translateY(calc(100% - 58px));
        max-height: 80%;
      }
    `}
  `}
`

export const WidgetFooter = styled.div`
  padding: 1rem;
  border-top: 1px solid rgba(0,0,0,0.1);
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.15);
  z-index: 10;
  display: flex;
  ${Button} {
    flex-grow: 1;
  }
`